import { useParams, useNavigate } from 'react-router-dom';

export enum ClientTabs {
  Clients = 'all',
  Families = 'families',
}

export function useClientTab() {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: ClientTabs }>();

  const setTab = (value: ClientTabs) => {
    navigate(`/clients/${value}`);
  };

  return {
    currentTab: tab,
    setTab,
  };
}
